import React from "react";
import "./AboutUs.css";

const AboutUs: React.FC = () => {
  return (
    <div className="about-us-container">
      <div className="about-us-title">O nama</div>
      <section className="about-us-section">
        <div className="about-us-subtitle">Podaci o prodajnom mjestu:</div>
        <div className="about-us-content">
          <div className="about-us-text">CoreEvent d.o.o.</div>
          <div className="about-us-text">
            Dunjevac 15, 10000 Zagreb, Hrvatska
          </div>
          <div>E-mail: support@core-event.co</div>
          <div>Mob: +385 98 919 7815</div>
          <div className="about-us-text">OIB: 36611335369</div>
          <div className="about-us-text">
            Društvo je upisano u sudski registar Trgovačkog suda u Zagrebu pod
            brojem 081377997
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
